import { Location } from '@angular/common';
import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { APIService } from 'src/app/services/APIService';
import { AuthService } from 'src/app/services/auth.service';
import { CentroSelezioneService } from 'src/app/services/centroSelezione.service';
import { CommonService } from 'src/app/services/common.service';
import { LocalUtilService } from 'src/app/services/local-util.service';
import { MessagesService } from 'src/app/services/messages.service';
import { OrganizationService } from 'src/app/services/organization.service';

@Component({
    selector: 'app-coripet-centri-di-selezione',
    templateUrl: './centri-di-selezione.component.html',
    styleUrls: ['./centri-di-selezione.component.css'],
    standalone: false
})
export class CoripetCentriDiSelezioneComponent extends APIService {

  
  constructor(public localService: LocalUtilService,
    public authService: AuthService,
    public organizationService: OrganizationService,
    public centroSelezioneService: CentroSelezioneService,
    private modalService: NgbModal,
    private messageService: MessagesService,
    public commonService: CommonService,
    location: Location, 
    router: Router, translateService: TranslateService) {
    super(localService, location, router, translateService);
        
  }

}
